export default class MarkPaymentAsCompleted {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, itemId }) {
    this.context.gateways.creditCard.complete({ customerId, itemId });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/secure_data/mark_payment_as_completed.js